"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var radio_input_style_1 = require("../../components/input/radio.input.style");
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-DepartmentSelector',
    btn: 'c-DepartmentSelector__Btn',
    icon: 'c-DepartmentSelector__Icon',
    department: 'c-DepartmentSelector__Department',
    departmentOptions: 'c-DepartmentSelector__Options',
    departmentOption: 'c-DepartmentSelector__Option',
    departmentDisabled: 'c-DepartmentSelector__Department__Disabled'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        position: 'relative'
    },
    _a[exports.CSS.btn] = {
        display: 'flex',
        'align-items': 'center',
        'max-width': '300px',
        'text-transform': 'none'
    },
    _a[exports.CSS.department] = {
        margin: "0 ".concat(theme_1.DefaultTheme.space(2)),
        color: theme_1.DefaultTheme.font.color.white,
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.departmentOptions] = (_b = {
            width: '600px',
            display: 'flex',
            'flex-direction': 'column'
        },
        _b["& .".concat(radio_input_style_1.CSS.container)] = {
            cursor: 'pointer',
            'border-bottom': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider),
            color: theme_1.DefaultTheme.font.color.primary
        },
        _b["& .".concat(radio_input_style_1.CSS.container, ":hover")] = {
            'background-color': theme_1.DefaultTheme.background.lightGrey
        },
        _b),
    _a[exports.CSS.departmentDisabled] = {
        color: theme_1.DefaultTheme.font.color.error
    },
    _a);
//# sourceMappingURL=department.selector.style.js.map